export default {
  nav: {
    home: "الرئيسية",
    lab: "مختبر الإصلاح",
    phones: "الهواتف",
    showroom: "المعرض",
    visit: "زيارتنا والتواصل",
    getEstimate: "تقدير السعر",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    menu: "القائمة",
    sound: "الصوت",
    call: "اتصل",
    tagline: "إصلاح الهواتف · كالغاري",
  },
  status: {
    openNow: "مفتوح الآن",
    closed: "مغلق",
    until: "حتى",
    opensToday: "يفتح اليوم الساعة",
    opensTomorrow: "يفتح غدًا الساعة",
    opensSunday: "يفتح الأحد الساعة",
  },
  hero: {
    h1a: "أجهزتك المعطلة،",
    h1b: "بعناية",
    h1c: "تعود إلى الحياة.",
    sub: "نيكست-جي لإصلاح الهواتف يصلح الهواتف واللابتوبات والتقنية اليومية في ورشة حقيقية في كالغاري — إجابات صريحة وعمل متقن، ولا يبدأ شيء دون موافقتك.",
    ctaQuote: "احصل على تقدير الإصلاح",
    ctaVisit: "زيارة المحل",
    est: "كالغاري، ألبرتا",
    badge: "بيع وإصلاح",
  },
  marquee: [
    "إصلاح الشاشات", "استبدال البطارية", "منافذ الشحن", "أضرار الماء",
    "وحدات الكاميرا", "استرجاع البيانات", "صيانة اللابتوب", "إنقاذ البرامج",
  ],
  process: {
    chapter: "01",
    eyebrow: "طريقة عملنا",
    title: "أربع خطوات. بلا غموض، بلا ضغط.",
    lede: "كل إصلاح في نيكست-جي يتبع نفس الإيقاع الصادق — تعرف دائمًا ما يحدث لجهازك وكم سيكلف.",
    steps: [
      { num: "01", title: "أحضر الجهاز", body: "تعال بالجهاز كما هو — بلا موعد، بلا تغليف، بلا نماذج. إذا تعرض للبلل، أبقه مغلقًا وتعال مباشرة." },
      { num: "02", title: "نشخّص العطل", body: "نفتح الجهاز، نختبر العتاد ونخبرك بلغة بسيطة ما الذي تعطل فعلًا — وما الذي سليم. بلا مصطلحات معقدة، بلا تخمين." },
      { num: "03", title: "أنت توافق", body: "تحصل على سعر واضح بالدولار الكندي قبل أي عمل. لا يبدأ شيء حتى تقول نعم — وإذا كان الإصلاح غير مجدٍ، نخبرك بذلك أيضًا." },
      { num: "04", title: "يعود إلى يديك", body: "نصلح، نختبر كل وظيفة من جديد، ونسلمك الجهاز يعمل — مع القطعة القديمة إن أردت رؤيتها." },
    ],
  },
  highlights: {
    chapter: "02",
    eyebrow: "ما نصلحه",
    title: "هواتف ولابتوبات وكل ما تعتمد عليه يوميًا.",
    items: [
      { title: "إصلاح الهواتف", body: "شاشات وبطاريات ومنافذ وكاميرات وأضرار ماء لآيفون وأندرويد." },
      { title: "إصلاح اللابتوب", body: "ماك بوك ولابتوبات ويندوز — إصلاحات عتاد وترقيات وإنقاذ الأنظمة البطيئة." },
      { title: "دعم البرامج", body: "مشاكل الإقلاع والتحديثات الفاشلة والأعطال ومشاكل الحسابات، تُحل بهدوء." },
      { title: "تشخيص الأجهزة", body: "لا تعرف ما المشكلة؟ فحص على طاولة العمل يخبرك بالضبط ما يحدث." },
      { title: "معرض الإكسسوارات", body: "أغطية وواقيات وشواحن وصوتيات ومعدات صنّاع المحتوى — تُركّب في المحل." },
    ],
  },
  teaser: {
    chapter: "03",
    eyebrow: "تقدير في دقيقة",
    titleA: "اختر المشكلة.",
    titleEm: "ثم اتصل",
    titleB: "— وسنسعّرها لك فورًا.",
    body: "اختر جهازك والمشكلة — ثم اتصل بالمحل بهذه التفاصيل واحصل على سعر صريح وواضح فورًا.",
    steps: ["اختر جهازك", "اختر المشكلة", "اتصل بالتفاصيل"],
    ctaStart: "ابدأ التقدير",
    ctaCall: "اتصل",
    pricesLabel: "أسعار بداية صادقة",
    prices: ["كل إصلاح ابتداءً من CA $79", "شاشات وبطاريات ومنافذ وكاميرات وأكثر", "الفحص مجاني دائمًا"],
  },
  location: {
    chapter: "04",
    eyebrow: "موقع المحل",
    titleEm: "— بجوار بنك TD.",
    lede: "الزيارة بدون موعد مرحب بها. أحضر الجهاز كما هو، ونحن نتكفل بالباقي.",
    openMaps: "افتح في الخرائط",
    visitContact: "زيارة وتواصل",
  },
  lab: {
    chapter: "مختبر الإصلاح",
    eyebrow: "الخدمات",
    titleA: "كل إصلاح، مشروح",
    titleEm: "بلغة بسيطة.",
    lede: "اضغط على أي خدمة لترى ما تغطيه والأعراض التي تحلها. طلب التقدير مجاني دائمًا — والعمل لا يبدأ إلا بموافقتك.",
    notice: "قد تلاحظ",
    ask: "اطلب تقديرًا",
    pricingTitle: "كيف تعمل أسعارنا",
    pricingBody: "النطاقات على الإنترنت أرقام مبدئية للتخطيط بالدولار الكندي. السعر النهائي يُؤكد بعد فحص الجهاز وتحديد الموديل بدقة والتحقق من توفر القطع — ولا يبدأ العمل إلا بموافقتك على السعر.",
    ctaTitleA: "لست متأكدًا أيهما يناسب؟",
    ctaTitleEm: "فقط اسأل.",
    ctaBody: "صف ما يفعله الجهاز — وسنرشدك إلى الإصلاح الصحيح.",
    ctaQuote: "احصل على تقدير الإصلاح",
    ctaCall: "اتصل",
    services: {
      screen: {
        title: "إصلاح الشاشة المكسورة",
        blurb: "زجاج متشقق، بكسلات ميتة، خطوط على الشاشة أو لمس توقف عن الاستجابة. نستبدل شاشات الهواتف والتابلت واللابتوب بقطع بجودة مطابقة.",
        symptoms: ["زجاج متشقق أو محطم", "اللمس لا يستجيب", "خطوط أو بقع أو مناطق سوداء", "الشاشة سوداء لكن الهاتف يهتز"],
      },
      battery: {
        title: "استبدال البطارية",
        blurb: "إذا كان هاتفك يموت عند 30٪ أو ينطفئ في البرد أو يعيش على الشاحن، فبطارية جديدة تعيده عادةً. نفحص الصحة قبل وبعد.",
        symptoms: ["البطارية تفرغ خلال ساعات", "انطفاءات عشوائية", "بطارية منتفخة ترفع الشاشة", "يعمل فقط وهو موصول بالشاحن"],
      },
      charging: {
        title: "مشاكل منفذ الشحن والطاقة",
        blurb: "كوابل غير ثابتة، شحن بطيء أو هاتف لا يشحن إلا بزاوية معينة. ننظف ونصلح ونستبدل منافذ الشحن ونتتبع مشاكل الطاقة حتى اللوحة عند الحاجة.",
        symptoms: ["الكابل غير ثابت أو يسقط", "يشحن فقط بزاوية معينة", "لا يشحن إطلاقًا", "الشحن اللاسلكي يعمل والمنفذ لا"],
      },
      backglass: {
        title: "الزجاج الخلفي وأضرار الهيكل",
        blurb: "الزجاج الخلفي المتشقق والإطار المعوج ليسا شكليين فقط — يدخل منهما الغبار والرطوبة. نستبدل الزجاج الخلفي ونرمم الهيكل ليُغلق الجهاز من جديد.",
        symptoms: ["زجاج خلفي متشقق أو محطم", "حواف حادة عند الإمساك", "إطار معوج أو منبعج", "حلقة الكاميرا رخوة أو تهتز"],
      },
      camera: {
        title: "استبدال وإصلاح الكاميرا",
        blurb: "صور ضبابية، عدسة تهتز، تركيز متعثر أو تطبيق كاميرا يفتح على شاشة سوداء. نستبدل زجاج العدسة ووحدات الكاميرا الأمامية والخلفية.",
        symptoms: ["الصور ضبابية دائمًا", "الكاميرا تهتز أو تصدر صوتًا", "شاشة سوداء في تطبيق الكاميرا", "زجاج العدسة متشقق"],
      },
      water: {
        title: "تقييم أضرار الماء",
        blurb: "السائل داخل الجهاز سباق مع التآكل. أحضره مغلقًا — نفتحه، ننظف التآكل ونقيّم ما يمكن إنقاذه قبل تسعير أي عمل.",
        symptoms: ["سقط في الماء أو انسكب عليه سائل", "الشاشة تومض بعد البلل", "الهاتف مات بعد السائل", "رطوبة ظاهرة تحت الكاميرا أو الشاشة"],
      },
      software: {
        title: "البرامج والأعطال والإقلاع",
        blurb: "عالق على الشعار، تحديثات فاشلة، أعطال متكررة أو حسابات مقفلة. نحل مشاكل البرامج، نستعيد الأنظمة ونساعدك على الدخول إلى جهازك.",
        symptoms: ["عالق على شعار البدء", "فشل التحديث والجهاز لا يقلع", "التطبيقات تتعطل باستمرار", "مقفل خارج حساباتك أو جهازك"],
      },
      data: {
        title: "استرجاع البيانات والوصول للجهاز",
        blurb: "صور وجهات اتصال وملفات محاصرة في جهاز ميت أو متضرر. نسترجع البيانات من الهواتف واللابتوبات متى سمح العتاد — حتى لو لم يعد الجهاز يعمل.",
        symptoms: ["الجهاز لا يعمل لكن البيانات مهمة", "صور أو ملفات محاصرة في هاتف مكسور", "حالات نسيان رمز الدخول", "قرص لابتوب معطل"],
      },
      laptop: {
        title: "دعم عتاد وبرامج اللابتوب",
        blurb: "شاشات ولوحات مفاتيح وبطاريات وترقيات تخزين وأنظمة بطيئة وتنظيف فيروسات — ماك بوك وويندوز يحصلان على نفس عناية الهواتف.",
        symptoms: ["شاشة لابتوب متشققة", "مفاتيح ميتة أو تكتب خطأ", "اللابتوب بطيء فجأة", "لا يشحن أو لا يحفظ الشحن"],
      },
      diagnostics: {
        title: "التشخيص واستشارة الإصلاح",
        blurb: "لا تعرف ما العطل؟ أحضره. نفحص الجهاز، نخبرك بلغة بسيطة بما يحدث فعلًا، ونسعّر الإصلاح قبل بدء أي عمل.",
        symptoms: ["شيء غير طبيعي دون وضوح السبب", "رأي ثانٍ على عرض محل آخر", "جهاز قديم — هل يستحق الإصلاح؟", "عدة مشاكل معًا"],
      },
      cleaning: {
        title: "خدمة التنظيف العميق",
        blurb: "وبر الجيوب والغبار والأوساخ يسدّون السماعات والمنافذ والأزرار ببطء. نفتح الجهاز وننظفه من الداخل والخارج بالكامل — وكثيرًا ما يحل هذا الصوت المكتوم والأزرار اللزجة.",
        symptoms: ["سماعات مكتومة أو ضعيفة", "منفذ الشحن مليء بالوبر", "أزرار لزجة أو عالقة", "غبار تحت زجاج الكاميرا"],
      },
    },
  },
  fixboth: {
    eyebrow: "هواتف وأجهزة لابتوب",
    title: "هاتف مكسور. لابتوب مكسور. محطة واحدة.",
    steps: [
      "آيفون 17 برو ماكس — شاشة وظهر متشققان",
      "لابتوبات ويندوز — HP وDell وغيرها",
      "ماك بوك — شاشات وبطاريات ولوحات مفاتيح",
      "اخرج به يعمل كالجديد",
    ],
    cta: "احصل على تقدير الإصلاح",
  },
  buy: {
    shopLink: "تصفح الهواتف",
    eyebrow: "هواتف جديدة ومستعملة",
    titleA: "بيع و",
    titleEm: "إصلاح",
    titleB: "— محل واحد يغطي كل شيء.",
    lede: "نبيع هواتف جديدة ومستعملة — سامسونج وآيفون وجوجل بكسل — كلها مختبرة ومفعّلة وجاهزة للاستخدام. المستعمل بحالة ممتازة فقط.",
    perks: [
      { title: "ضمان من 6 إلى 12 شهرًا", body: "كل هاتف مع ضمان من 6 أشهر حتى سنة كاملة." },
      { title: "واقي + غطاء مجانًا", body: "واقي شاشة مقوّى عالي الجودة وغطاء هاتف مجانًا مع كل هاتف تشتريه." },
      { title: "خصومات للعملاء الدائمين", body: "كل عملية شراء تضيفك إلى خصومات مستقبلية — كلما اشتريت أكثر، وفّرت أكثر." },
      { title: "مختبر ومفعّل", body: "مختبر بالكامل ومفعّل وجاهز للاستخدام لحظة خروجك من المحل." },
    ],
    bestPrice: "أفضل أسعار الهواتف في كالغاري وإدمونتون — بل في ألبرتا كلها.",
    brandsTitle: "ماذا نبيع",
    seriesNote: "…والمزيد على الرف. اتصل لتعرف المتوفر اليوم.",
    cta: "اتصل لمعرفة المتوفر",
    iphoneLine: "آيفون 5 وما فوق",
    pixelLine: "بكسل 6 وما فوق",
  },
  showroom: {
    chapter: "المعرض",
    eyebrow: "إكسسوارات وتقنية يومية",
    titleA: "رف صغير",
    titleEm: "منتقى بعناية",
    titleB: "— ليس مستودعًا.",
    lede: "أغطية وحماية وطاقة وصوتيات، مختارة للحياة اليومية. كل شيء هنا يمكن تركيبه أو تجربته على جهازك عند الكاونتر.",
    groups: { all: "الكل", phones: "هواتف", protection: "الحماية", power: "الطاقة", audio: "الصوتيات", wearables: "ساعات", car: "السيارة", studio: "الاستوديو" },
    availability: "التوفر والأسعار تُؤكد في المحل",
    stripEyebrow: "تعال وشاهد بنفسك",
    stripTitle: "الرف يتغير كثيرًا — والتصفح مجاني.",
    stripVisit: "خطط لزيارتك",
    stripQuote: "احصل على تقدير الإصلاح",
    items: {
      phones: { title: "هواتف جديدة ومستعملة", blurb: "سامسونج وآيفون وجوجل بكسل — مختبرة ومفعّلة وجاهزة للاستخدام، بضمان من 6 أشهر حتى سنة كاملة." },
      cases: { title: "أغطية الهواتف", blurb: "أغطية رفيعة ومتينة وشفافة ملائمة لموديلك بالضبط — جربها على هاتفك في المحل." },
      protectors: { title: "واقيات الشاشة وحماية الكاميرا", blurb: "زجاج مقوّى وزجاج خصوصية، مع حماية للعدسة — تُركّب عند الكاونتر بينما تنتظر." },
      cables: { title: "كوابل وشواحن سريعة", blurb: "كوابل USB-C ولايتننغ مضفورة، وشواحن سريعة عالية الجودة لآيفون وأندرويد والتابلت." },
      power: { title: "باور بانك وشواحن", blurb: "شواحن جدارية سريعة، شواحن لاسلكية، موزعات متعددة وباور بانك للسفر والتنقلات الطويلة." },
      car: { title: "إكسسوارات السيارة", blurb: "حوامل ومساند للهاتف، وشواحن سيارة سلكية ولاسلكية لكل جهاز." },
      audio: { title: "إيربودز وسماعات", blurb: "إيربودز وسماعات لاسلكية وسماعات رأس — للاستماع اليومي." },
      speakers: { title: "مكبرات صوت صغيرة لاسلكية", blurb: "مكبرات محمولة جاهزة للخارج، بصوت كبير وحجم صغير." },
      smartwatches: { title: "ساعات ذكية اقتصادية", blurb: "ساعات يومية تقيس نبض القلب وتحسب الخطوات وتتصل بهاتفك." },
      memory: { title: "كروت ذاكرة", blurb: "كروت microSD بكل السعات، للهواتف والكاميرات والتابلت." },
      keyboards: { title: "لوحات مفاتيح", blurb: "لوحات سلكية ولاسلكية للعمل والدراسة واللعب." },
      creatorkit: { title: "عدة صناعة المحتوى", blurb: "إضاءة دائرية، ترايبود محمول وثابت، والمزيد لصنّاع المحتوى." },
      creator: { title: "معدات صنّاع المحتوى والعمل من المنزل", blurb: "حوامل ثلاثية، مساند، إضاءة دائرية وترقيات مكتبية صغيرة للمكالمات والدروس والمحتوى." },
      addons: { title: "إكسسوارات يومية للهاتف واللابتوب", blurb: "مساند وأغطية وموزعات والأشياء الصغيرة التي تجعل جهازك أسهل في الاستخدام." },
      preowned: { title: "أجهزة وقطع بديلة", blurb: "اسأل عند الكاونتر عن الأجهزة وقطع الغيار المتوفرة حاليًا على الرف." },
    },
  },
  visit: {
    chapter: "زيارتنا والتواصل",
    eyebrow: "تفضل بزيارتنا",
    titleA: "المحل في 17th Ave SE،",
    titleEm: "بجوار بنك TD مباشرة.",
    lede: "الزيارة بدون موعد مرحب بها خلال ساعات العمل. أحضر الجهاز كما هو — لا حاجة لموعد.",
    addressLabel: "العنوان",
    hoursLabel: "ساعات العمل",
    call: "اتصل",
    text: "راسل المحل نصيًا",
    email: "راسلنا عبر البريد",
    openMaps: "افتح في الخرائط",
    planEyebrow: "تفضل التخطيط أولًا؟",
    planTitle: "احصل على تقدير مبدئي قبل مشوار الزيارة.",
    planCta: "احصل على تقدير الإصلاح",
    mapTitle: "خريطة الوصول إلى نيكست-جي لإصلاح الهواتف",
  },
  quote: {
    eyebrow: "تقدير الإصلاح",
    titleA: "رقم واضح،",
    titleEm: "في دقيقة تقريبًا.",
    lede: "ثلاثة اختيارات سريعة تخبرنا بالمشكلة. ثم اتصل — سنعطيك سعرًا واضحًا فورًا، بموافقتك قبل أي عمل.",
    step: "الخطوة",
    of: "من",
    stepTitle1: "ما الذي سنصلحه؟",
    stepTitle2: "أي جيل، تقريبًا؟",
    stepTitle3: "ما المشكلة؟",
    back: "رجوع",
    preliminary: "تقدير مبدئي",
    planning: "نطاق استرشادي",
    factorsTitle: "ما الذي يحدد السعر النهائي",
    factors: [
      "الموديل الدقيق وجودة القطعة المتوفرة له",
      "مدى انتشار الضرر داخل الجهاز",
      "توفر القطع وأسعار الموردين في ذلك الأسبوع",
      "أي مشاكل إضافية تُكتشف أثناء الفحص المجاني",
    ],
    disclaimer: "هذا نطاق مبدئي غير ملزم. القطع والموديل الدقيق والتشخيص والتوفر قد تغير السعر النهائي — ويُؤكد معك دائمًا قبل بدء العمل.",
    call: "اتصل",
    text: "أرسل هذا التقدير نصيًا",
    email: "راسل المحل",
    startOver: "ابدأ من جديد",
    visitShop: "زيارة المحل",
    categories: {
      iphone: { label: "آيفون", blurb: "كل الأجيال، من آيفون 8 إلى أحدث موديلات برو." },
      android: { label: "هاتف أندرويد", blurb: "سامسونج وجوجل بكسل وأجهزة أندرويد الأخرى." },
      tablet: { label: "تابلت", blurb: "آيباد وتابلت أندرويد بكل الأحجام." },
      laptop: { label: "لابتوب", blurb: "ماك بوك ولابتوبات ويندوز، عتاد وبرامج." },
    },
    tiers: {
      iphone: {
        older: { label: "آيفون أقدم", hint: "آيفون 8 وX وجيل SE" },
        recent: { label: "آيفون حديث", hint: "جيل آيفون 11 إلى 14" },
        newest: { label: "آيفون أحدث / برو", hint: "آيفون 15 إلى 17 وموديلات برو" },
      },
      android: {
        standard: { label: "أندرويد قياسي", hint: "هواتف الفئة الاقتصادية والمتوسطة" },
        recent: { label: "أندرويد حديث", hint: "موديلات حديثة شائعة" },
        flagship: { label: "أندرويد رائد", hint: "جالاكسي S / ألترا، بكسل برو وما شابه" },
      },
      tablet: {
        standard: { label: "تابلت قياسي", hint: "تابلت يومي وأقدم" },
        recent: { label: "تابلت حديث", hint: "موديلات آيباد وأندرويد حديثة" },
        pro: { label: "تابلت برو", hint: "آيباد برو والتابلت الكبير الفاخر" },
      },
      laptop: {
        standard: { label: "لابتوب قياسي", hint: "لابتوبات يومية وأقدم" },
        recent: { label: "لابتوب حديث", hint: "موديلات حديثة شائعة وألترابوك" },
        pro: { label: "لابتوب ألعاب / برو", hint: "أجهزة ألعاب، ماك بوك برو ومحطات عمل" },
      },
    },
    issues: {
      screen: { label: "شاشة مكسورة", hint: "شقوق أو بكسلات ميتة أو مشاكل لمس" },
      battery: { label: "استبدال البطارية", hint: "تفريغ سريع، انطفاءات، انتفاخ أو صحة ضعيفة" },
      charging: { label: "مشكلة شحن", hint: "منفذ رخو، لا يشحن أو طاقة متقطعة" },
      backglass: { label: "زجاج خلفي مكسور", hint: "زجاج خلفي متشقق أو ضرر في الهيكل" },
      camera: { label: "مشكلة كاميرا", hint: "عدسة متضررة، مشاكل تركيز أو وحدة معطلة" },
      water: { label: "أضرار ماء", hint: "تعرض للرطوبة، تآكل أو لا يعمل" },
      software: { label: "مشكلة برامج", hint: "أعطال، تحديثات، إقلاع أو مشاكل حسابات" },
      data: { label: "استرجاع بيانات", hint: "صور، ملفات أو مشاكل وصول للجهاز" },
    },
    smsBody: "مرحبًا نيكست-جي، أتصل بخصوص إصلاح. الجهاز: {device}. المشكلة: {issue}.",
    emailSubject: "طلب إصلاح — نيكست-جي",
    resultTitle: "تم — لم يبقَ إلا الاتصال.",
    callNow: "اتصل الآن",
    callLead: "كل إصلاح مختلف، لذلك نسعّر مباشرة بدل التخمين على الإنترنت. اتصل بهذه التفاصيل وستحصل على إجابة صريحة فورًا.",
    readyTitle: "جهّز هذه عند الاتصال",
    ready: ["موديلك الدقيق إن كنت تعرفه", "ما الذي يفعله الجهاز — أو توقف عن فعله", "متى بدأت المشكلة"],
    noPrice: "لا يبدأ شيء دون موافقتك. السعر الذي تسمعه في المكالمة هو الذي توافق عليه.",
  },
  footer: {
    explore: "استكشف",
    talk: "تواصل معنا",
    hours: "الساعات",
    quote: "تقدير السعر",
    rights: "كالغاري، ألبرتا",
    line: "الزيارة بدون موعد مرحب بها · التقديرات تُؤكد قبل أي عمل",
    motto: "خدمة الجيل القادم للجيل القادم.",
  },
};
